import {useMutation, UseMutationOptions} from "@tanstack/react-query";
import axios, {AxiosError} from "axios";
import {ResponseError} from "../../../models/common/Response";
import {RoleMaster} from "../../../models/config/RoleMaster";
import {useLocation} from "react-router";
import {useMemo} from "react";
import {useMenuName} from "../../../hooks";
import {extractAccessToken} from "../../../helpers/jwt";

export function useAddRoleMaster(
    options?: UseMutationOptions<
        RoleMaster,
        AxiosError<ResponseError>,
        RoleMaster
    >
) {
    const menuName = useMenuName();
    
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.post('/v1/configuration/lis/role', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    ['X-Resource']: menuName,
                    ['X-Citizen-Id']: extractAccessToken().citizen_id
                }
            });
        },
        ...options
    });
}